module.exports = __webpack_public_path__ + "static/thinkster-e1ddeeb677e4f8503007be37a1b7bb2b.png";